import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
  const { colors } = useContextState()
  const { breakpoints } = useTheme()
  return {
    headerLeft: {
      display: 'flex',
      width: 'fit-content',
      alignItems: 'center',
      '& .MuiIconButton-root': {
        color: colors.color4,
        fontWeight: '600',
        marginLeft: '-10px',
      },
      '& .MuiTypography-root': {
        fontSize: '17px',
        fontWeight: '400',
        color: colors.color4,
      }
    },
    title: {
      flexGrow: 1,
      fontSize: '22px',
      fontWeight: '500'
    },
    mainContainer: (showButon: boolean) => ({
      minHeight: '70vh',
      paddingLeft: 3,
      paddingRight: 3,
      paddingBottom: showButon ? 6 : 1,
    }),
    containerStatus: {
      display: 'flex',
      alignItems: 'center',
    },
    setting: {
      '&.MuiIconButton-root': {
        padding: '0px'
      }
    },
    conatinerTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    flex: (showTable:boolean) => ({
      display: 'flex',
      flexDirection: 'column',
      gap: showTable ? 1:3
    }),
    flex1: {
      display: 'flex',
      flexDirection: 'column',
      gap: 1
    },
    containerDate: {
      marginTop: 1
    },
    containerButtons: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingBottom: 1,
      paddingLeft: 3,
      paddingRight: 3,
      //paddingTop: 1
    },

  }
}

export { useStyles }
